const congratspoints = [
  {
    point: "Settle your debts from 50% plus discount",
  },
  {
    point: "Protection from Creditors Harassment",
  },
  {
    point: "Legal cover from our in-house advocates",
  },
  {
    point: "Dedicated relationship manager",
  },
  {
    point: "Money protected in a Trust account",
  },
  {
    point: "Client dashboard",
  },
];

export default congratspoints;
